import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation, inject, input } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { NgClass } from '@angular/common';
import { CoreMenuVerticalSectionComponent } from './vertical/section/section';
import { CoreMenuVerticalItemComponent } from './vertical/item/item';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { CoreMenuVerticalCollapsibleComponent } from './vertical/collapsible/collapsible';
import { CoreMenuHorizontalCollapsibleComponent } from './horizontal/collapsible/collapsible';
import { CoreMenuHorizontalItemComponent } from './horizontal/item/item';

@Component({
    selector: '[core-menu]',
    templateUrl: './core-menu.html',
    styleUrl: './core-menu.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CoreMenuVerticalSectionComponent, CoreMenuVerticalItemComponent, NgClass, DefaultClassDirective, RouterLinkActive, RouterLink, CoreMenuVerticalCollapsibleComponent, CoreMenuHorizontalCollapsibleComponent, CoreMenuHorizontalItemComponent]
})
export class CoreMenuComponent implements OnInit {
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _coreMenuService = inject(CoreMenuService);

  currentUser: any;

  readonly layout = input('vertical');

  @Input()
  menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.currentUser = this._coreMenuService.currentUser;
      console.log('this.currentUser',this.currentUser)
      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();

      this._changeDetectorRef.markForCheck();
    });
  }
}
